import { v7 } from "uuid";

// v7 is time-ordered: leading bits encode a Unix ms timestamp, so
// lexicographic sort ≈ insertion order. The backend returns goods sorted
// by id, so this keeps rows in the order the user added them.
export const getGuid = () => {
  return v7();
};
